import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { ContactModel, ContactTypeModel } from '../interfaces/company-account-data';
import { Employee } from '../../shared/interfaces/client-data';
import { catchError } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})
export class ClientContactsService {
    constructor(private http: HttpClient) {}

    private serverUrl = 'https://' + window.location.host;
    private version = '0.5'; // TODO Get version number dynamically
    private _url = (this.serverUrl + '/api/v{version}/clientcontacts').replace(
        '{version}',
        this.version
    );

    getContacts(clientKey: number): Observable<ContactModel[]> {
        const params = new HttpParams().set('clientKey', clientKey.toString());
        return this.http.get<ContactModel[]>(this._url + '/GetClientContact/', {
            params: params,
        });
    }
    getContactsByName(clientShortName: string): Observable<ContactModel[]> {
        const params = new HttpParams().set('clientShortName', clientShortName);
        return this.http.get<ContactModel[]>(this._url + '/GetClientContactByClientShortName/', {
            params: params,
        });
    }
    getContactTypes(): Observable<ContactTypeModel[]> {
        return this.http.get<ContactTypeModel[]>(this._url + '/GetContactTypes');
    }

    updateContact(updateContact: ContactModel, shortName: string): Observable<any> {
        const params = {
            data: updateContact,

            clientshortName: shortName,
        };
        return new Observable((subscriber) => {
            this.http
                .post<any>(
                    `https://${window.location.host}/api/v0.5/ClientContacts/UpdateClientContact`,
                    params
                )
                .subscribe(
                    () => {
                        subscriber.next(true);
                    },
                    (response) => {
                        subscriber.error(response);
                    }
                );
        });
    }

    // only for additional Super Clients
    insertNewContact(insertContact: ContactModel, shortName: string): Observable<any> {
        const params = {
            data: insertContact,

            clientshortName: shortName,
        };
        return new Observable((subscriber) => {
            this.http
                .post<any>(
                    `https://${window.location.host}/api/v0.5/ClientContacts/InsertClientContact`,
                    params
                )
                .subscribe(
                    () => {
                        subscriber.next(true);
                    },
                    (response) => {
                        subscriber.error(response);
                    }
                );
        });
    }

    // only for additional Super Clients - can prob just sent contact key
    deleteContact(updateContact: ContactModel, shortName: string): Observable<any> {
        return new Observable((subscriber) => {
            const params = {
                data: updateContact,

                clientshortName: shortName,
            };
            this.http
                .post<any>(
                    `https://${window.location.host}/api/v0.5/ClientContacts/DeleteClientContact`,
                    params
                )
                .subscribe(
                    () => {
                        subscriber.next(true);
                    },
                    (response) => {
                        subscriber.error(response);
                    }
                );
        });
    }
}
